import axios from 'axios';

/**
 * load data from Tsv file
 * @param {string} filename
 * @param {number} headerLineCount
 * @param {function} transformerFunction
 * @return rows
 */
export async function loadFromTsv(filename, headerLineCount, transformerFunction) {
    let response = await axios.post(`/api/cirt/get${filename}`)
    let rows = [];
    let headers = [];
    let file = response.data;
    let lineNum = 0;
    for (let line of file.split(/\r?\n/)) {
        let object = line.split('\t');
        lineNum++;
        if (lineNum <= headerLineCount || line.length === 0) {
            if (lineNum === headerLineCount) {
                headers = object;
            }
            continue;
        }
        let tuple = line.split(/\t/);
        let transformed = transformerFunction(Object.fromEntries(headers.map((_, i) => [headers[i], tuple[i]])), lineNum);
        rows.push(transformed);
    }
    return rows;
}